/* Testimonials collapse */
import { Collapse } from '@/shared/common/collapse/collapse';

const testimonials = document.querySelector('.js-testimonials-container');

export const mainTestimonialsCollapse = () => {
	testimonials &&
		new Collapse(testimonials, {
			selectorElement: '.js-testimonials-container__element',
			selectorButton: '.js-testimonials-container__button',
			selectorContent: '.js-testimonials-container__content',
		});
};

/* Set height for testimonials on desktop */

const container = document.querySelector('.js-testimonials-container__content');
const items = container?.querySelectorAll('.js-collapse__content');
const laptopMQ = window.matchMedia(`(min-width: ${window.vars.breakpoint.laptop}px)`);
let itemHeight = 0;

setTestimonialsHeight();
laptopMQ.addEventListener('change', setTestimonialsHeight);

function setTestimonialsHeight() {
	if (!container || !items) {
		return;
	}

	if (laptopMQ.matches) {
		items?.forEach((item) => {
			itemHeight = item.offsetHeight > itemHeight ? item.offsetHeight : itemHeight;
		});
		container?.style.setProperty('--testimonials-container-height', `${itemHeight + 32}px`);
	} else {
		container?.style.setProperty('--testimonials-container-height', `0`);
	}
}
